import { gql } from '@apollo/client';

export const QUERY_FACIAL_HAIRS = gql`
  query facialHairs {
    facialHairs {
      id
      name
    }
  }
`;
